module.exports = {
  generate: function generate() {
    const copyrightTextIDs = [
      'b2b-mobile-footer-copyright-current-year',
      'b2b-web-footer-copyright-current-year',
    ];

    copyrightTextIDs.forEach(function replaceCurrentYear(id) {
      const textContainer = document.getElementById(id);
      const currentYear = new Date().getFullYear().toString();

      textContainer.textContent = currentYear;
    });
  },
};
